import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { PropertyType } from "../../../shared/types/properties/PropertyTypes";
import { IndexPropertiesResponse } from "../response/IndexPropertiesResponse";

const API_VERSION = "v4";

interface FilterProps {
    id?: string;
    channex_id?: string;
    name?: string;
    preferred_currency?: string;
    is_full_sync?: string;
    is_property_active?: string;
    primary_email?: string;
    primary_phone?: string;
    property_type?: PropertyType;
    needs_review?: string;
    group_id?: string;
    billing_connected?: string;
}

interface GetAllBookingProps {
    filter?: FilterProps;
    search?: string;
    orderBy?: string;
    sort?: string;
    limit?: number;
    page?: number;
    all?: number | boolean;
    include?: string;
}

const useIndexProperties = (query: GetAllBookingProps) => {
    return useQuery({
        queryKey: [
            'properties',
            query?.all ? 'all' : '',
            ...Object.entries(query.filter ?? {})
                .filter(([_key, value]) => value !== undefined && value !== null && value !== "")
                .map(([key, value]) => `${key}:${value}`),
            query.search,
            query.orderBy,
            query.sort,
            query.limit,
            query.page,
            query.include ? `include:${query.include}` : ''
        ],
        queryFn: async () => {
            try {
                const params = {
                    filter: Object.fromEntries(
                        Object.entries(query.filter ?? {}).filter(([_key, value]) => value !== undefined && value !== null && value !== "")
                    ),
                    search: query.search || "",
                    orderBy: query.orderBy || "",
                    sort: query.sort || "",
                    limit: query.limit || 10,
                    page: query.page || 1,
                    all: query.all || false,
                    include: query.include || undefined
                };

                const response = await privateApi.get(`/${API_VERSION}/property`, { params });

                // Validasi response
                const validationResult = IndexPropertiesResponse.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid properties data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch properties`, error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useIndexProperties;